var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOffSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 1.50085C13.25 1.00867 12.9609 0.563355 12.5117 0.36023C12.0625 0.157105 11.5352 0.239136 11.168 0.567261L5.89844 5.25085H3.25C1.87109 5.25085 0.75 6.37195 0.75 7.75085V10.2509C0.75 11.6298 1.87109 12.7509 3.25 12.7509H5.89844L11.168 17.4344C11.5352 17.7626 12.0625 17.8407 12.5117 17.6415C12.9609 17.4423 13.25 16.993 13.25 16.5009V1.50085Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOffSolid);
export default __webpack_public_path__ + "static/media/volume-off-solid.b432a67054af0682711607400fc9fae1.svg";
export { ForwardRef as ReactComponent };